import { ReactNode } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

interface Props {
  title: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
}

export const DashboardGroupHeading = ({ title, icon, action }: Props) => (
  <Stack direction="row" alignItems="center" height={36} gap={0.75} sx={{ px: 0.5, color: 'text.secondary' }}>
    {icon}
    <Typography
      component="h2"
      variant="overline"
      sx={{ fontWeight: 700, letterSpacing: '0.08em', lineHeight: 1 }}
    >
      {title}
    </Typography>
    <Divider sx={{ flexGrow: 1 }} />
    {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
  </Stack>
);
